import { createTranslatedText } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { ChipFilter } from './ChipFilter';

type PatientFilterProps = {
   readonly label: string | undefined;
};

export const PatientChipFilter = (props: PatientFilterProps): JSX.Element | null => {
   const { patientId } = visitPaths.useAppointmentsListSearchParams();
   if (!patientId) {
      return null;
   }

   return (
      <ChipFilter
         label={createTranslatedText(props.label) ?? 'visit:appointments.unknownPatient'}
         searchParamKey={visitPaths.APPOINTMENTS_PATIENT_SEARCH_PARAM}
         testId={'patientChipFilter'}
      />
   );
};
